import {
	ICMMSLocation,
	LocationInput,
	LocationTypes,
} from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { LocationNodeTypes } from '../types';
import { ILocationAssetInput } from '@app/pages/cmms/interfaces/assets.interfaces';

export function formatCmmsLocationsToNode(
	locations: ICMMSLocation[]
): LocationNodeTypes[] {
	return locations.map(
		location =>
			({
				id: location.locationId,
				name: location.name,
				contentType: location.locationType.toLowerCase(),
			}) as LocationNodeTypes
	);
}

export function formatCmmsLocationsToInput(locations: ICMMSLocation[]): LocationInput[] {
	return locations.map(
		location =>
			({
				locationId: location.locationId,
				name: location.name,
				locationType:
					location.locationType.slice(0, 1).toUpperCase() +
					location.locationType.slice(1),
			}) as LocationInput
	);
}
export function formatAssetLocationToInput(
	locations: ILocationAssetInput
): LocationInput[] {
	return [
		{
			locationId: locations.id,
			name: locations.name,
			locationType: (locations.type.slice(0, 1).toUpperCase() +
				locations.type.slice(1)) as LocationTypes,
		},
	];
}
